<!-- Ported from the Polaris kit: src/components/ui/table/TableRow.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <tr
    data-slot="table-row"
    :class="
      cn(
        'hover:bg-polaris-muted/50 data-[state=selected]:bg-polaris-muted border-b border-solid border-polaris-border transition-colors',
        props.class
      )
    "
  >
    <slot />
  </tr>
</template>
